import { View, ViewDensity, ViewType } from "@common/types/views/views";
import { BatchGroupColumn } from "./batchGroupsViewConfig";

export const defaultBatchGroupsView: View = {
    type: ViewType.HISTORY_BATCH_GROUPS,
    columns: [
        { id: BatchGroupColumn.DATE },
        { id: BatchGroupColumn.COUNT },
        { id: BatchGroupColumn.CONDITIONS },
        { id: BatchGroupColumn.ACTIONS, options: { pin: "right" } },
    ],
    filters: {},
    options: {
        selection: true,
        density: ViewDensity.MD,
    },
};
